<template>
    <van-popup v-if="costPopupShow " :value="costPopupShow" z-index="100" :close-on-click-overlay="false"
               :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
        <div class="project_record_wrap" ref="recordDialog" v-loading="loading">
            <div class="project_record_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>
            </div>

            <div class="project_record_bottom">
                <van-form colon ref="formData" scroll-to-error>
                    <ul>
                        <li>
                            <van-field :rules="formRules.cost_name"  label="成本名称" input-align="right"  placeholder="请输入" required  v-model="formData.cost_name"></van-field>
                        </li>
                        <li>
                            <van-field :rules="formRules.price" type="number"  label="成本金额" input-align="right"  placeholder="请输入" required  v-model="formData.price"></van-field>
                        </li>
                        <li>
                            <div   class="vertical_input_wrap">
                                <van-field v-model="formData.note"  label="成本详情" placeholder="请输入" type="textarea"></van-field>
                            </div>
                        </li>
                    </ul>
                </van-form>
            </div>

            <div class="project_record_footer_wrap">
                <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
            </div>

        </div>
    </van-popup>
</template>

<script>
import {  ProjectManageCostAdd,ProjectManageCostEdit,ProjectManageCostDetail }from "@/api/index.js"
import {Dialog} from "vant";
export default {
    name: "cost_tpl",
    components: { },
    props: {
        costPopupShow: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: [String,Number],
            default: '0'
        },
        costId: {
            type: [String,Number],
            default: 0
        },

    },
    data() {
        return {
            defaultImg: require('@/assets/images/default.jpg'),
            loading:false,
            btnDisabled:false,
            formData: {
                cost_name:"",
                price:0.00,
                note: "",
            },
            formRules: {
                cost_name: [{required: true, message: "请输入成本名称", trigger: 'onBlur'}],
                price: [{required: true, message: "请输入成本金额", trigger: 'onChange'}],
            },
        };
    },

    created() {
        if(this.costId){
            this.getProjectManageCostDetail()
        }
    },
    methods: {
        getProjectManageCostDetail(){
            let postData = {
                id:this.costId
            }
            this.loading = true
            ProjectManageCostDetail(postData).then(res => {
                if (res.code === 200) {
                    let {cost_name,price,note} = res.data
                    this.formData.cost_name = cost_name
                    this.formData.price = price
                    this.formData.note = note

                }
                this.loading = false
            })
        },
        handleClickClose(){
            this.$emit("update:costPopupShow", false)
        },

        handleClickConfirm(){
            this.$refs.formData.validate().then(() => {
                let postData = JSON.parse(JSON.stringify(this.formData))
                postData.price = parseFloat(postData.price).toFixed(2)
                postData.project_manage_id = this.projectId
                this.btnDisabled = true
                if(this.costId){
                    postData.id = this.costId
                    ProjectManageCostEdit(postData).then(res => {
                        if (res.code === 200) {
                            this.$toast({
                                message:res.message,
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.$emit("update:costPopupShow", false)
                                    this.$emit('success')
                                },
                            });
                        }
                        this.btnDisabled = false
                    })
                }else {
                    ProjectManageCostAdd(postData).then(res => {
                        if (res.code === 200) {
                            this.$toast({
                                message:res.message,
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.$emit("update:costPopupShow", false)
                                    this.$emit('success')
                                },
                            });
                        }
                        this.btnDisabled = false
                    })
                }
            })
        },


    },
}
</script>

<style  lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>